import React from "react"
import Skeleton from "@components/Skeleton/Skeleton"

export default function GenericSaltPageSkeleton() {
    return (
        <div className="page-container pY-16">
            {/* Header Section */}
            <div className="pX-36 pY-12">
                <div className="col-8">
                    <Skeleton config={[{ span: 8, height: "36px", classes: "" }]} />
                </div>
            </div>

            {/* Main Content - 3 Column Layout */}
            <div className="flex pX-36 padding-8-0">
                {/* Left Column - Information + Author + Editorial */}
                <div className="col-8">
                    {/* Information Section */}
                    <Skeleton
                        config={[
                            { span: 8, height: "27px", classes: "marginBottom-8" }, // Section header
                            { span: 8, height: "18px", classes: "marginBottom-8" }, // Uses header
                            { span: 8, height: "60px", classes: "marginBottom-16" }, // Uses content
                            { span: 8, height: "18px", classes: "marginBottom-8" }, // How it works header
                            { span: 8, height: "40px", classes: "marginBottom-16" }, // How it works content
                            { span: 8, height: "18px", classes: "marginBottom-8" }, // Side effects header
                            { span: 8, height: "20px", classes: "marginBottom-8" }, // Side effects text
                            { span: 8, height: "40px", classes: "marginBottom-16" }, // Side effects content
                        ]}
                    />

                    {/* Author Section */}
                    <div className="pTop-16">
                        <Skeleton
                            config={[
                                { span: 8, height: "18px", classes: "marginBottom-8" }, // Content details header
                                { span: 8, height: "1px", classes: "marginBottom-16" }, // Separator
                                { span: 8, height: "60px", classes: "marginBottom-8" }, // Author 1
                                { span: 8, height: "60px", classes: "marginBottom-16" }, // Author 2
                                { span: 8, height: "16px", classes: "marginBottom-8" }, // Last updated
                            ]}
                        />
                    </div>

                    {/* Editorial Policy Section */}
                    <div className="pTop-16">
                        <Skeleton
                            config={[
                                { span: 8, height: "80px", classes: "" }, // Editorial card
                            ]}
                        />
                    </div>
                </div>

                {/* Middle Column - Available Medicine */}
                <div className="col-8 pX-12">
                    <div className="flexColumn">
                        <Skeleton
                            config={[
                                { span: 8, height: "24px", classes: "marginBottom-8" }, // Section header
                                { span: 8, height: "1px", classes: "marginBottom-16" }, // Separator
                                { span: 8, height: "50px", classes: "marginBottom-8" }, // Brand 1
                                { span: 8, height: "50px", classes: "marginBottom-8" }, // Brand 2
                                { span: 8, height: "50px", classes: "marginBottom-8" }, // Brand 3
                                { span: 8, height: "50px", classes: "marginBottom-8" }, // Brand 4
                                { span: 8, height: "50px", classes: "marginBottom-8" }, // Brand 5
                                { span: 8, height: "50px", classes: "marginBottom-8" }, // Brand 6
                                { span: 8, height: "50px", classes: "marginBottom-8" }, // Brand 7
                                { span: 8, height: "50px", classes: "marginBottom-8" }, // Brand 8
                                { span: 8, height: "50px", classes: "marginBottom-8" }, // Brand 9
                                { span: 8, height: "50px", classes: "" }, // Brand 10
                            ]}
                        />
                    </div>
                </div>

                {/* Right Column - Expert Advice */}
                <div className="col-8 pX-12">
                    <div className="flexColumn">
                        <Skeleton
                            config={[
                                { span: 8, height: "24px", classes: "marginBottom-8" }, // Section header
                                { span: 8, height: "1px", classes: "marginBottom-16" }, // Separator
                                { span: 8, height: "300px", classes: "" }, // Expert advice content (long list)
                            ]}
                        />
                    </div>
                </div>
            </div>

            {/* FAQ Section - Full Width */}
            <div className="pX-36 pTop-16 flex justifyCenter">
                <div className="col-18 flexColumn justifyCenter">
                    <Skeleton
                        config={[
                            { span: 12, height: "24px", classes: "marginBottom-8" }, // FAQ header
                            { span: 12, height: "1px", classes: "marginBottom-16" }, // Separator
                            { span: 12, height: "48px", classes: "marginBottom-8" }, // FAQ 1
                            { span: 12, height: "48px", classes: "marginBottom-8" }, // FAQ 2
                            { span: 12, height: "48px", classes: "marginBottom-8" }, // FAQ 3
                            { span: 12, height: "48px", classes: "marginBottom-8" }, // FAQ 4
                            { span: 12, height: "48px", classes: "marginBottom-8" }, // FAQ 5
                            { span: 12, height: "48px", classes: "marginBottom-8" }, // FAQ 6
                            { span: 12, height: "48px", classes: "marginBottom-8" }, // FAQ 7
                            { span: 12, height: "48px", classes: "marginBottom-8" }, // FAQ 8
                            { span: 12, height: "48px", classes: "" }, // FAQ 9
                        ]}
                    />
                </div>
            </div>
        </div>
    )
}
